const WpsOfficeIcon = /*#__PURE__*/ [
  ["path", { d: "M13.5 14.5L15.5 18.5L22 5.5H15L12 11.5L8.5 18.5L2 5.5H9L10.5 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { WpsOfficeIcon as default };
//# sourceMappingURL=WpsOfficeIcon.js.map
